<template>
  <div :class="{ collapse: collapse }" class="sidebar-logo-container">
    <transition name="sidebarLogoFade">
      <div v-if="collapse" key="collapse" class="sidebar-logo-link">
        <img :src="logo" class="sidebar-logo" />
      </div>
      <div key="expand" class="sidebar-logo-link">
        <img :src="logo" class="sidebar-logo" />
        <h1 class="sidebar-title">{{ title }}</h1>
      </div>
    </transition>
  </div>
</template>

<script>
import Hamburger from '@/components/Hamburger';
import { mapGetters } from 'vuex';

export default {
  name: 'SidebarLogo',
  components: {
    Hamburger,
  },
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      title: '牛运宝2.0',
      logo: require('@/layout/components/Sidebar/logo.png'),
    };
  },
  computed: {
    groupName() {
      return this.$store.state.user.groupName.replace('有限公司', '') || '';
    },
    ...mapGetters(['sidebar', 'name', 'device', 'changePassword']),
  },
  watch: {
    changePassword: {
      deep: true,
      immediate: true,
      handler(val) {
        this.dialogFormVisible = !(val && val !== '0');
        this.dialogFormVisible = false;
      },
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #fff;
  & .sidebar-logo-link {
    height: 50px;
    width: 100%;
    box-shadow: 0px 5px 8px 0px rgba(230, 225, 225, 0.5);
    position: relative;
    z-index: 99999;
    & .sidebar-logo {
      width: 24px;
      height: 24px;
      vertical-align: middle;
      margin-right: 8px;
      margin-left: 20px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #181818;
      width: 96px;
      overflow: hidden;
      font-weight: 600;
      line-height: 50px;
      font-size: 16px;
      vertical-align: middle;
      white-space: nowrap;
    }
    & .hamburger-container {
      display: inline-block;
      color: #000;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
